import { enGB as en, fr, nl } from 'date-fns/locale'

export const locales: any = {
    en,
    fr,
    nl
};
